import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'GenerationStep' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: '#8E8E8E',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        whiteSpace: 'nowrap'
    },
    _completed: {
        color: '#232323'
    },
    _active: {
        color: '#232323',
        fontWeight: 600
    }
});
